module.exports = __webpack_public_path__ + "media/packs/autocatalog/components/mobile/SpecSummary/images/gearbox-d7b711ff9958be4879e10ac0c9b4cde9.png";